import { useRouter } from 'next/router'

import { useAppSelector } from '~/redux/hooks'

import { selectUserId } from '~/auth/slices/auth.slice'

import { selectBootcampPageActivities } from '../slices/bootcamp-page.slice'
import { selectBootcampActivityEvents } from '../slices/bootcamp-activity.slice'

import { BootcampPageUrlParamsType, LevelActionType } from '../types/bootcamp.types'

import useGetCurrentDifficultyLevel from './useGetCurrentDifficultyLevel'
import useGetCollectedRewards from './useGetCollectedRewards'
import useGetAvailableRewards from './useGetAvailableRewards'

function useShowRoundSummary(): boolean {
  const userId = useAppSelector(selectUserId)
  const activities = useAppSelector(selectBootcampPageActivities)
  const events = useAppSelector(selectBootcampActivityEvents)
  const [, hasCompletedAllDifficultyLevel] = useGetCurrentDifficultyLevel(events, activities)
  const collectedRewards = useGetCollectedRewards(events)
  const availableRewards = useGetAvailableRewards(activities)
  const { query: urlQuery } = useRouter()
  const { action } = urlQuery as unknown as BootcampPageUrlParamsType

  const isActivityPage = action === LevelActionType.Activity

  return !!(isActivityPage && hasCompletedAllDifficultyLevel && userId && collectedRewards === availableRewards)
}

export default useShowRoundSummary
